<template>
	<div style="background: #F9F9F9;" v-loading="loading">
		<HomeBannerTop></HomeBannerTop>
		<!-- 会议周 首页轮播图1 -->
		<div class="home-huiyizhou flex-center">
			<swiper :options="swiperTopBannerOption" class="swiper-container top_swiper" v-if="actorListBannerTopSwiper.length > 1">
				<swiper-slide class="swiper-slide" v-for="(item, index) in actorListBannerTopSwiper" :key="index">
					<a href="javascript:void(0)" @click="openUrl(option[index])">
						<img :src="item.coverIcon" :item="JSON.stringify(item)" />
					</a>
				</swiper-slide>
				<div slot="pagination" class="swiper-pagination" />
			</swiper>
			<template v-else-if="actorListBannerTopSwiper.length == 1">
				<div class="singleBox" style="">
					<a href="javascript:void(0)" @click="openUrl(actorListBannerTopSwiper[0])">
						<img :src="actorListBannerTopSwiper[0].coverIcon" />
					</a>
				</div>
			</template>
		</div>
		<div class="home-search flex-center">
			<div class="m-r-10">
				<el-input class="home-search-input" :placeholder="$t('输入供应商，产品或展位名称搜索')" prefix-icon="el-icon-search"
					v-model="query.searchKeywords">
				</el-input>
			</div>
			<div class="flex flex-start">
				<div class="m-r-10 home-search-btn pointer" @click="searchList()">
					<img src="@/assets/home/cn/sousuo.png" />
					<span>{{ $t('搜索') }}</span>
				</div>
				<div class="m-r-10 home-search-btn1 pointer" @click="goHome()">
					<span>{{ $t('返回首页') }}</span>
				</div>
			</div>
		</div>
		<div class="tagSearch-div" v-loading="loading2" v-if="false">
			<div class="tagSearch-box">
				<TagSearch v-if="questionSite.questionList && questionSite.questionList.length > 0" :questionSite="questionSite"
					:questionListValue.sync="questionListValue" :checkInfoValue.sync="initial" @searchList="searchList('find')" />
			</div>
		</div>

		<div class="actor-list-box">
			<template v-if="dataList.length > 0">

				<div v-for="(item,index) in dataListTop" :key="item.id">
					<actorCard showType="find" :index="index" :vData="item" @collect="collectEvent_a" />
				</div>
				<div class="list_swiper flex-center" v-if="bannerSwiper1.length>0">
					<swiper :options="swiperOption" class="swiper-container" v-if="bannerSwiper1.length > 1">
						<swiper-slide class="swiper-slide" v-for="(item, index) in bannerSwiper1" :key="index">
							<a href="javascript:void(0)" @click="openUrl(option[index])">
								<img :src="item.coverIcon" :item="JSON.stringify(item)" />
							</a>
						</swiper-slide>
						<div slot="pagination" class="swiper-pagination" />
					</swiper>
					<template v-else-if="bannerSwiper1.length == 1">
						<div class="singleBox" style="">
							<a href="javascript:void(0)" @click="openUrl(bannerSwiper1[0])">
								<img :src="bannerSwiper1[0].coverIcon" />
							</a>
						</div>
					</template>
				</div>
				<div v-for="(item, index) in dataListBottom" :key="item.id">
					<actorCard showType="find" :index="index" :vData="item" @collect="collectEvent_a" />
				</div>
			</template>
			<template v-else>
				<hNoData></hNoData>
			</template>

		</div>
		<div class="tc mt20">
			<el-pagination v-if="dataList.length > 0" background @current-change="handleCurrentChange"
				:page-size="query.pageRows" :current-page.sync="query.pageNum" layout="total, prev, pager, next, jumper"
				:total="query.total">
			</el-pagination>
		</div>
		<!-- 底部信息 -->
		<HomeFooter></HomeFooter>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
// 顶部内容
import HomeBannerTop from '../index/HomeBannerTop'
// 底部内容
import HomeFooter from '../index/HomeFooter'


import { eventMixin } from '@/mixins/event.js'
import hNoData from '@/components/hNoData'
import TagSearch from './components/TagSearch'
import actorCard from './components/actorCard'
import { getProductTags, listByProjectId } from '@/api/index'
import { getRecommendedVisitorList, getSearchTrendInfo, searchVisitorList, recommendProductList, getRecommendedExhibitorsList } from '@/api/find'
import {
	getConfigurationItemList
} from '@/api/home'
export default {
	name: 'actorList',
	mixins: [eventMixin],
	components: {
		actorCard,
		HomeBannerTop,
		HomeFooter,
		TagSearch,
		actorCard,
		hNoData
	},
	computed: {
		...mapGetters(['language', 'info', 'isLogin', 'subjectType', 'fromUrl'])
	},
	// 添加多语言metaInfo配置
	metaInfo() {
		const isChinese = this.$store.getters.language !== 'en';
		const canonicalUrl = 'https://cacizt-pc.eastfair.com/actorList';
		
		if (isChinese) {
			return {
				title: '展商列表 - CAC2026中国国际农用化学品及植保展览会',
				meta: [
					{
						name: 'description',
						content: '查看CAC2026中国国际农用化学品及植保展览会的所有参展商列表，包括农药、肥料、植保器械等领域的知名企业。'
					},
					{
						name: 'keywords',
						content: '展商列表, 农药企业, 肥料公司, 植保器械厂商, CAC2026参展商'
					}
				],
				link: [
					{
						rel: 'canonical',
						href: canonicalUrl
					}
				]
			};
		} else {
			return {
				title: 'Exhibitor List - CAC2026 China International Agrochemical & Crop Protection Exhibition',
				meta: [
					{
						name: 'description',
						content: 'View the complete list of exhibitors at CAC2026 China International Agrochemical & Crop Protection Exhibition, including leading companies in pesticides, fertilizers, crop protection equipment and more.'
					},
					{
						name: 'keywords',
						content: 'Exhibitor List, Pesticide Companies, Fertilizer Manufacturers, Crop Protection Equipment Suppliers, CAC2026 Exhibitors'
					}
				],
				link: [
					{
						rel: 'canonical',
						href: canonicalUrl
					}
				]
			};
		}
	},
	data() {
		return {
			loading: false, // 页面loading
			loading2: false, // 筛选loading
			questionSite: {}, // 问卷内容
			questionListValue: [], // 筛选条件
			initial: '', // 首字母查询
			dataList: [], // 数据
			dataListTop: [], // 前3条数据,
			dataListBottom: [], // 后7条数据,
			query: { // 搜索值
				pageNum: 1,
				pageRows: 10,
				total: 0,
				searchKeywords: ''
			},
			code: this.$route.query?.code || '', // 广告图code
			// swiper配置
			swiperOption: {
				slidesPerView: 'auto',
				// autoplay: false,
				loop: true,
				autoplay: {
					disableOnInteraction: false,
					delay: 3000
				}
			},
			bannerSwiper1: [], // 中部轮播图
			swiperTopBannerOption: {
				slidesPerView: 'auto',
				// autoplay: false,
				loop: true,
				autoplay: {
					disableOnInteraction: false,
					delay: 3000
				},
				pagination: {
					el: '.swiper-pagination',
					clickable: true
				},
			},
			actorListBannerTopSwiper: [] // 顶部轮播图
		}
	},
	mounted() {
		sessionStorage.removeItem('actorID')
		// 没有值，中文环境默认all，英文默认all_en
		if (!this.$route.query?.code) {
			this.code = this.language == 'en' ? 'all_en' : 'all'
		}
		this.getBannerList()
		this.pageInit()
		this.getlistByProjectId()
	},
	methods: {
		openUrl(data) {
			if (data.type == 'EXTERNAL' && data.url) {
				window.open(data.url, '_blank')
			}
		},
		getlistByProjectId() {
			listByProjectId()
				.then(res => {
					return res.data
				})
				.then(res => {
					if (res.code === 1000) {
						let data = res.data
						if (this.code) {
							data.filter(element => {
								if (element.code == this.code) {
									this.bannerSwiper1 = element.pageConfigDetailsList
									return this.bannerSwiper1
								}
							})
							console.log('this.bannerSwiper1---->', this.bannerSwiper1)
						}
					}
				})
				.finally(() => {})
		},
		// 更新收藏状态
		updateCollect(status, index) {
			this.dataList[index]['collected'] = status
		},
		// 找展商 收藏
		collectEvent_a(params, index, data) {
			if (!this.isLogin) {
				sessionStorage.setItem('actorID', data.id)
			}
			params.collectionSubjectId = data.id
			params.id = data.collectionId
			this.collectEvent(params, index)
		},
		// 返回首页
		goHome() {
			this.$router.push(`/`)
		},
		// 页码 change
		handleCurrentChange(page) {
			this.query.pageNum = page
			if (this.$route.query.type) {
				var list = JSON.parse(this.$route.query.type)
				this.fetchDataList(list)
			} else {
				this.fetchDataList()
			}
			this.$funcs.scrollToY(0, 10)
		},
		// 初始化
		pageInit() {
			this.getProductTags()
			if (this.$route.query.keywords) {
				this.query.searchKeywords = this.$route.query.keywords
			}
			if (this.$route.query.type) {
				var list = JSON.parse(this.$route.query.type)
				this.fetchDataList(list)
			} else {
				this.fetchDataList()
			}

		},
		// 获取标签列表
		getProductTags() {
			let showType = 'ACTOR_LIST'
			this.loading2 = true
			getProductTags({
				showType
			})
				.then(res => {
					return res.data
				})
				.then(res => {
					if (res.code === 1000) {
						let data = res.data
						// 只取第一个
						data.questionList = [data.questionList[0]]
						data.questionList.selectedType = 'multiple';
						data.questionList.map((e) => {
							e.selectedType = 'multiple'
						})
						this.questionSite = data
					}
				})
				.finally(() => {
					this.loading2 = false
				})
		},
		// 搜索
		searchList(type) {
			this.loading = true
			this.loading2 = true
			this.listType = 'search'
			let questionList = this.questionListValue
			if (type != 'search') {
				this.query.pageNum = 1
			}
			// 如果是分类进来的，筛选时还按分类数据进行搜索
			if (this.questionListValue.length > 0) {
				this.fetchDataList(questionList)
			} else {
				if (this.$route.query.type) {
					var list = JSON.parse(this.$route.query.type)
					this.fetchDataList(list)
				} else {
					this.fetchDataList()
				}
			}
		},
		// 获取列表
		fetchDataList(questionList) {
			this.loading = true
			questionList = questionList || this.questionListValue
			this.fetchActorList(questionList)
		},
		// 获取展商列表
		fetchActorList(questionList) {
			let tagIds = sessionStorage.getItem('findListActor') || ''
			getRecommendedExhibitorsList({
				...this.query,
				tagIds,
				questionList,
				initial: this.initial,
				showType: 'ACTOR_LIST',
				// exhibitionFloor: this.exhibitionFloor,
				exhibitorSort: 'recommend_custom_letter_asc'
			})
				.then(res => {
					return res.data
				})
				.then(res => {
					if (res.code === 1000) {
						let data = res.data
						this.query.total = data.total || 0
						this.query.pages = data.pages || 0
						this.dataList = data.list || []
						this.dataListTop = this.dataList.slice(0, 3);
						this.dataListBottom = this.dataList.slice(3);

					}
				})
				.finally(() => {
					this.loading = false
					this.loading2 = false
				})
		},
		// 获取顶部bannner
		getBannerList() {
			getConfigurationItemList({
				sourceType: 1
			})
				.then(res => {
					return res.data
				})
				.then(res => {
					if (res.code === 1000 && res.data) {
						// pc电子会刊轮播图1
						if (res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'] && res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'].length != 0) {
							for (let i in res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER']) {
								if (
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'EXTERNAL' ||
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'TAG_EXHIBITOR' ||
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'ACTOR_DETAILS' ||
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'TAG_PRODUCT' ||
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'PRODUCT_DETAILS' ||
									res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i]['urlType'] === 'LIST_EXHIBITOR'
								) {
									this.actorListBannerTopSwiper.push(res.data.bannerMap['PC_JOURNAL_ACTORlIST_TOP_SWIPER'][i])
								}
							}
							this.actorListBannerTopSwiper.sort(this.sortSequence)
						}
						console.log('this.actorListBannerTopSwiper:', this.actorListBannerTopSwiper)
					}
				})
		},
	}
}
</script>

<style lang="scss" scoped>
.home-search {
	width: 100%;
	background: #DAE3E8;
	padding: 32px;
}

.home-search-input {
	width: 798px;
	height: 54px;
	line-height: 54px;
	border-radius: 6px;

	display: inline-block;
	border: 0;
	outline: none;
	font-size: 16px;
	padding: 0 20px;
	padding-left: 0px;

	::v-deep input {
		height: 54px;
		line-height: 54px;
		padding-left: 35px;
	}

	&::placeholder {
		font-size: 18px;
		color: rgba(0, 0, 0, 0.25);
	}
}

.home-search-btn {
	line-height: 54px;
	padding: 0 20px;
	background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
	border-radius: 6px;
	color: #fff;
	font-size: 18px;
	width: max-content;
}
.home-search-btn1 {
	line-height: 54px;
	padding: 0 20px;
	background: -webkit-linear-gradient(top, #00875e, #0068a9);
	-webkit-background-clip: text;
	-webkit-text-fill-color: transparent;
	background-clip: text;
	border-radius: 6px;
	color: #fff;
	font-size: 18px;
	width: max-content;
	border: 1px solid rgba(0, 135, 94, 1);
}
.tagSearch-div{
	width: 100%;
	background: #fff;
	box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.15);
}
.tagSearch-box{
	max-width: 1280px;
	margin: auto;
}
.actor-list-box{
	max-width: 1080px;
	margin: auto;
	background: #fff;
	margin-top: 16px;
	padding:24px;
}
.list_swiper{
	margin-bottom: 24px;
}
::v-deep .swiper-pagination-bullet {
	width: 10px;
	height: 10px;
	display: inline-block;
	border-radius: 100%;
	background: #fff;
	opacity: 1;
	margin: 0 4px;
}
.top_swiper{
	margin: auto;
	text-align: center;
}

/* 激活状态的分页器子弹样式 */
::v-deep .swiper-pagination-bullet-active {
	opacity: 1;
	background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
	border-radius: 7px;
	width: 48px;
}
@media (min-width: 320px) and (max-width: 750px) {
	.home-search {
			padding: 16px;
		}
	
		.home-search-input {
			width: auto !important;
		}
	
		.home-search-input {
			width: auto !important;
			height: 35px;
			line-height: 35px;
			border-radius: 6px;
	
			display: inline-block;
			border: 0;
			outline: none;
			font-size: 12px;
			padding: 0 8px;
			padding-left: 0px;
	
			::v-deep input {
				height: 35px;
				line-height: 35px;
				padding-left: 30px;
			}
	
			&::placeholder {
				font-size: 12px;
				color: rgba(0, 0, 0, 0.25);
			}
		}
	
		.home-search-btn {
			line-height: 35px;
			padding: 0 8px;
			background: linear-gradient(90deg, #00875E 0%, #0068A9 100%);
			border-radius: 6px;
			color: #fff;
			font-size: 11px;
			width: max-content;
		}

		.home-search-btn1 {
			line-height: 35px;
			padding: 0 8px;
			background: -webkit-linear-gradient(top, #00875e, #0068a9);
			-webkit-background-clip: text;
			-webkit-text-fill-color: transparent;
			background-clip: text;
			border-radius: 6px;
			color: #fff;
			font-size: 11px;
			width: max-content;
			border: 1px solid rgba(0, 135, 94, 1);

		}
	
		.home-fenlei {
			width: 100%;
			padding: 16px 16px 0 16px;
			background: #F9F9F9;
	
			img {
				width: 100%;
				margin-bottom: 16px;
			}
		}
}
</style>